import React from 'react';
import Styles from './index.less';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import i18n from '@i18next/i18n';
import { IDataHelper, IShapeProps, ISlideDataModel } from '@tencent/slide-sdk-model';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { IShapeStyles } from '@src/framework/workbench/ui/shape/shape-fast-style/fast-style-config';
import { ShapePropertyConverter } from '@src/slide/domain/ui-model/converter/node-property/element/shape-property-converter';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { DeepPartial } from 'ts-essentials';
import { IShapeModelStyle } from '@src/slide/domain/ui-model/element-modeles/Interface/model-props/shape-model-props.interface';
import { ColorConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/color/color-converter';
import { ITDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';

export interface IShapeFastStyleCardProps {
    onClick: (style) => void;
    text: string;
    shapeStyles: IShapeStyles;
    slideModel: ISlideModel;
}

export default class ShapeFastStyleCard extends React.PureComponent<IShapeFastStyleCardProps> {
    public render() {
        const { text } = this.props;
        const { shapeStyle, textStyle } = this.getShapeStyle(this.props.shapeStyles);
        return (
            <Tooltip title={text} trigger="hover" placement={'top'} overlayHoverable={false}>
                <div
                    className={Styles['shape-fast-style-card']}
                    onClick={this.handleClick}
                >
                    <div className={Styles['shape-fast-style-card-text-wrapper']} style={shapeStyle}>
                        <div className={Styles['shape-fast-style-card-shape']}></div>
                        <span className={Styles['shape-fast-style-card-text']} style={textStyle}>{i18n.t('文')}</span>
                    </div>
                </div>
            </Tooltip>
        );
    }

    // eslint-disable-next-line complexity
    private getShapeStyle = (styleConfig: IShapeStyles) => {
        const slideModelData = this.props.slideModel.sdkData as ISlideDataModel;
        const dataHelper = SlideDataServices.SDKDataServices.DataHelper() as IDataHelper;
        const { fill, fontColor, line, effectList } = dataHelper
            .getInheritedFastStyle(styleConfig.fastStyle, slideModelData);

        const uiModel = {
            props: {
                style: styleConfig.style || {},
            },
        };
        if (!styleConfig.style) {
            // 转成uiModel格式 方便统一处理
            const { solidFill, noFill, gradFill } = fill || {};
            const sdkData = {
                spPr: {
                    solidFill,
                    noFill,
                    gradFill,
                    ln: line,
                    effectLst: effectList,
                },
            };
            ShapePropertyConverter.convertPartialDataFromSdkToUi(
                sdkData as DeepPartial<IShapeProps>,
                uiModel as IShapeModel,
            );
        }

        const style = uiModel.props.style as Partial<IShapeModelStyle>;
        const shapeStyle: React.CSSProperties = {};
        if (style.border && !style.border.noFill) {
            if (style.border.tdColor) {
                shapeStyle.border = `${(style.border.width || 0) / 2}px ${style.border.style} ${this.getColor(style.border.tdColor as ITDColor)}`;
            } else if (style.border.gradFill) {
                shapeStyle.border = this.getGradFillStyle(style.border.gradFill);
            }
        }
        if (style.fillBackground && !style.fillBackground.noFill) {
            // 目前快速样式填充只可能包含solidFill和gradFill的linear渐变
            if (style.fillBackground.solidFill) {
                shapeStyle.background = this.getColor(style.fillBackground.solidFill.color);
            } else if (style.fillBackground.gradFill) {
                shapeStyle.background = this.getGradFillStyle(style.fillBackground.gradFill);
            }
        }
        // 目前快速样式效果只可能包含shadow
        if (style.effect?.shadow) {
            shapeStyle.boxShadow = '0px 2px 3px rgba(0, 0, 0, 0.37)';
        }
        return {
            shapeStyle,
            textStyle: {
                color: fontColor?.srgbClr?.val ? `#${fontColor.srgbClr.val}` : '',
            },
        };
    };

    private getGradFillStyle = (gradFillProps) => {
        const { gsList, lin } = gradFillProps || {};
        const gsColorStr = gsList.map((gs) => {
            if (gs.color?.srgbColor) return `${gs.color?.srgbColor} ${gs.pos}%`;
            return `${this.getColor(gs.color as ITDColor)} ${gs.pos}%`;
        }).join(', ');
        return `linear-gradient(${(lin?.ang || 0) - 270}deg, ${gsColorStr})`;
    };

    private getColor = (color: ITDColor): string => {
        if (color.srgbColor) return color.srgbColor;
        const colorSdk = {};
        ColorConverter.convertPartialDataFromUiToSdk(
            color,
            colorSdk,
        );
        const { slideModel } = this.props;
        const colorStr =  SlideDataServices.SDKDataServices.ColorManager()?.resolveColor(
            colorSdk,
            slideModel?.sdkData as ISlideDataModel,
        )?.srgbClr?.val;
        return colorStr ? `#${colorStr}` : '';
    };

    private handleClick = () => {
        this.props.onClick(this.props.shapeStyles);
    };
}
